export default __webpack_public_path__ + "static/media/bitcoin-cash.dbe75e2e.png";